import MaterialTable from "material-table";
import React, { forwardRef } from "react";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { Typography } from "@mui/material";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const renderCell = (data, field) => {
  return (
    <div>
      {data?.bold ? (
        <Typography fontSize="0.875rem" fontWeight="600">
          {data?.[field]}
        </Typography>
      ) : (
        <Typography fontSize="0.875rem">{data?.[field]}</Typography>
      )}
    </div>
  );
};

const headerStyle = {
  fontSize: "1rem",
};

const PlansTable = ({ data, type }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "auto",
        direction: "ltr",
      }}
    >
      <MaterialTable
        // style={{ width: "100%", marginTop: 10 }}
        icons={tableIcons}
        columns={[
          {
            title: `Plans ${type}`,
            field: "plan",
            headerStyle,
            render: (data) => renderCell(data, "plan"),
          },
          {
            title: "Total Sales",
            field: "total_sales",
            headerStyle,
            render: (data) => renderCell(data, "total_sales"),
          },
        ]}
        data={data}
        title={
          <h2>{/* <IntlMessages tagName="strong" id="Companies" /> */}</h2>
        }
        options={{
          search: false,
        }}
      />
    </div>
  );
};

export default PlansTable;
